<template>
    <div class="">
        <Header></Header>
        <div class="page-container">
            <div class="page-wrapper">
                <div class="page-back-wrapper">
                    <div class="page-location">
                        <span class="location-label">学习计划</span>
                        <img src="@/assets/img/more.png" alt="" class="location-img">
                        <span class="location-label hand-back" @click="handleBack">管理计划</span>
                        <img src="@/assets/img/more.png" alt="" class="location-img">
                        <span class="location-label2">其他计划</span>
                    </div>
                </div>
                <div class="page-content-container">
                    <div class="page-content-wrapper">
                        <div class="page-content">
                            <div class="header-container">
                                <div class="header-label">管理员</div>
                                <div class="search-container">
                                    <div class="page-mode-input-wrapper">
                                        <div class="page-mode-input">
                                            <el-select v-model="searchVal" placeholder="请选择" clearable>
                                                <el-option v-for="item in userList" :key="item.adminUserId"
                                                    :label="item.adminUserName" :value="item.adminUserId">
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <div class="input-btn" @click="handleSearch">
                                            <i class="el-icon-search input-btn-icon"></i>
                                            <span class="input-btn-label">搜索</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="tableData.length > 0">
                                <div v-for="(item, key) in tableData" :key="key" class="plan-wrapper">
                                    <div class="plan-header-container">
                                        <div class="plan-header-title-wrapper">
                                            <img src="@/assets/img/plan.png" alt="" class="header-img">
                                            <span class="plan-header-title">{{ item.typeName }}</span>
                                        </div>
                                    </div>
                                    <div v-for="(childItem, childKey) in planData" :key="'child-' + childKey">
                                        <div v-if="childItem.typeId == item.typeId" class="plan-content-wrapper"
                                            @mouseenter="enterRow(childItem)" @mouseleave="leaveRow(childItem)">
                                            <div class="plan-content-header-wrapper">
                                                <div class="plan-content-title-wrapper">
                                                    <div v-if="childItem.status == 2" class="plan-content-title-btn">创建未完成
                                                    </div>
                                                    <div class="plan-content-title">{{ childItem.planName }}</div>
                                                </div>
                                                <div class="plan-content-header-delete-wrapper">
                                                    <img v-if="activeHover == childItem.planId"
                                                        src="@/assets/img/delete.png" alt="" class="header-btn-img"
                                                        @click="handleDeletePlan(childItem)">
                                                </div>
                                            </div>
                                            <div class="plan-table-wrapper">
                                                <div class="plan-table-content">
                                                    <div class="plan-table-item">
                                                        开始：{{ childItem.planStartTime }}
                                                    </div>
                                                    <div class="plan-table-item">
                                                        结束：{{ childItem.planEndTime }}
                                                    </div>
                                                </div>
                                                <div class="plan-table-btn-wrapper">
                                                    <div class="plan-table-btn" @click="handlePalnDetail(childItem)">
                                                        预览
                                                    </div>
                                                    <div class="plan-table-btn" @click="handleEchartsReport(childItem)">
                                                        统计报表
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="no-data-wrapper">
                                <img src="@/assets/img/nodata.png" alt="" class="no-data-img">
                                <div class="no-data-label">暂无管理计划！</div>
                            </div>
                            <div class="view-more-btn-wrapper">
                                <div v-if="currentPage < totalPages" class="view-more-btn" @click="viewMore">查看更多</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog title="" :show-close="true" width="542px" :visible.sync="deletePlanDialog" class="team-manage-container">
            <div class="dialog-header">
                <div>温馨提示</div>
            </div>
            <div class="dialog-content">
                <div class="dialog-info">
                    <div class="dialog-info-label">
                        确认删除此学习计划？
                    </div>
                </div>
                <div class="dialog-btn-wrapper" style="justify-content:center;">
                    <div class="dialog-btn dialog-deal-btn" @click="deletePlan">确定</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import { otherPlanList, deletePlanRow, childAdminUserList } from '@/api/index.js';
export default {
    name: '',
    components: {
        Header
    },
    data() {
        return {
            dept: '',
            token: '',
            searchVal: '',
            userList: [],
            activeUser: {
                adminDeptId: '',
                adminUserId: '',
                adminUserName: ''
            },
            totalData: [],
            tableData: [],
            planData: [],
            currentPage: 1,
            totalPages: 1,
            activeHover: '',
            deletePlanDialog: false,
            activeDeletePlan: {}
        }
    },
    mounted() {
        this.dept = window.localStorage.getItem('dept');
        this.token = window.localStorage.getItem('token');
        this.getTableData();
        this.getUserList();
    },
    methods: {
        handleBack() {
            this.$router.go(-1);
            //  this.$router.push(`/studyplan/manage-plan`);
        },
        getTableData() {
            otherPlanList({
                "adminDeptId": this.activeUser.adminDeptId,
                "adminUserId": this.activeUser.adminUserId,
                "deptId": this.dept,
                "keyword": '',
                "pageNum": this.currentPage,
                "pageSize": 10000,
                "userId": 0
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data.list;
                    var lastData = this.totalData;
                    this.totalData = lastData.concat(data);
                    this.totalPages = res.data.totalPages;
                    this.resetTableData();
                }
                return;
            }).catch(err => {
               // console.log(err);
            });
        },
        resetTableData() {
            var dataArr = this.totalData;
            var titleArr = [];
            var contentArr = [];
            for (var i = 0; i < dataArr.length; i++) {
                var item = dataArr[i];
                if (item.planId == 0) {
                    titleArr.push(item);
                } else {
                    contentArr.push(item);
                }
                if (i == dataArr.length - 1) {
                    this.tableData = titleArr;
                   // console.log(contentArr, "*************************")
                    this.planData = contentArr;
                }
            }
        },
        handleSearch() {
            var searchVal = this.searchVal;
            this.totalData = []
            if (searchVal != '') {
                var userList = this.userList;
                for (var i = 0; i < userList.length; i++) {
                    var item = userList[i];
                    if (item.adminUserId == searchVal) {
                        this.currentPage = 1;
                        this.tableData = [];
                        this.activeUser = item;
                        this.getTableData();
                    }
                }
            } else {
                this.currentPage = 1;
                this.tableData = [];
                this.activeUser = {
                    adminDeptId: '',
                    adminUserId: '',
                    adminUserName: ''
                };
                this.getTableData();
            }
        },
        getUserList() {
            childAdminUserList({}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.userList = data;
                }
                return;
            }).catch(err => {
               // console.log(err);
            });
        },
        viewMore() {
            if (this.currentPage < this.totalPages) {
                this.currentPage = this.currentPage + 1;
                this.getTableData();
            }
        },
        enterRow(row) {
            var planId = row.planId;
            this.activeHover = planId;
        },
        leaveRow() {
            this.activeHover = '';
        },
        handleEchartsReport(row) {
            this.$router.push(`/echartsReport/${row.planId}`);
        },
        handlePalnDetail(row) {
            this.$router.push(`/planDetail/detail/${row.planId}`);
        },
        handleDeletePlan(row) {
            this.activeDeletePlan = row;
            this.deletePlanDialog = true;
        },
        deletePlan() {
            var id = this.activeDeletePlan.planId;
            deletePlanRow(id, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.totalData = [];
                    this.deleteModeDialog = false;
                    this.$message({
                        message: `删除成功`,
                        type: 'success'
                    });
                    this.getTableData();
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
               // console.log(err);
            });
        }
    }
}
</script>

<style scoped>
.page-container {
    width: 100%;
    margin: 0 auto;
}

.page-wrapper {
    width: 1200px;
    margin: 0 auto;
    padding: 100px;
}

.page-back-wrapper {
    width: 100%;
    height: 68px;
    background: #ffffff;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #f0f0f3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 18px;
}

.page-location {
    height: 100%;
    margin-left: 30px;
    display: flex;
    align-items: center;
}

.location-label {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3E63EE;
    margin-right: 12px;
}

.location-label2 {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;
    margin-right: 12px;
}

.location-img {
    width: 20px;
    height: 20px;
    margin-right: 12px;
}

.page-content-container {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #F0F0F3;
    margin-top: 18px;
}

.page-content-wrapper {
    display: flex;
}

.page-content {
    flex: 1;
    margin: 30px 41px 30px 45px;
}

.header-container {
    display: flex;
    align-items: center;
}

.search-container {
    display: flex;
    align-items: center;
}

.page-mode-input-wrapper {
    display: flex;
    width: 425px;
}

.page-mode-input>>>.el-input__inner {
    width: 350px !important;
    height: 38px !important;
    border-radius: 6px 0px 0px 6px !important;
    border: 1px solid #6D94FF !important;
    border-right: 0px !important;
}

.input-btn {
    width: 75px;
    height: 38px;
    background: #6D94FF;
    border-radius: 0px 6px 6px 0px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.input-btn:hover {
    cursor: pointer;
    opacity: 0.8;
}

.input-btn-icon {
    font-size: 13px;
}

.input-btn-label {
    margin-left: 5px;
}

.header-btn-wrapper {
    display: flex;
    margin-right: 15px;
}

.header-btn {
    height: 36px;
    border-radius: 6px;
    border: 1px solid #FF9645;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FF9645;
    line-height: 36px;
    padding: 0px 18px 0px 18px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.header-btn:hover {
    cursor: pointer;
    color: #fff;
    background: #FF9645;
}

.plan-header-title-wrapper {
    display: flex;
    align-items: center;
}

.plan-header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 36px;
    padding-bottom: 10px;
}

.header-img {
    width: 30px;
    height: 30px;
}

.plan-header-title {
    margin-left: 17px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #303B45;
}

.plan-header-btn-wrapper {
    display: flex;
    margin-right: 15px;
}

.header-btn-img {
    width: 20px;
    height: 20px;
    cursor: pointer;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.plan-content-wrapper {
    height: 164px;
    border-bottom: 1px solid #F0F0F0;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.plan-content-wrapper:hover {
    background: rgb(248, 248, 248);
}

.plan-content-header-wrapper {
    display: flex;
    justify-content: space-between;
    padding-top: 28px;
}

.plan-content-title-wrapper {
    display: flex;
    margin-left: 15px;
    align-items: center;
}

.plan-content-title-btn {
    width: 95px;
    height: 26px;
    background: #FE8766;
    border-radius: 6px;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 12px;
}

.plan-content-title {
    height: 30px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}

.plan-content-header-delete-wrapper {
    margin-right: 15px;
}

.plan-table-wrapper {
    display: flex;
    justify-content: space-between;
}

.plan-table-content {
    margin-left: 15px;
    margin-top: 15px;
}

.plan-table-item {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #848F9A;
    margin-top: 5px;
}

.plan-table-btn-wrapper {
    margin-right: 15px;
    display: flex;
}

.plan-table-btn {
    margin-left: 20px;
    width: 108px;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #3E63EE;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #3E63EE;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.plan-table-btn:hover {
    cursor: pointer;
    background: #3E63EE;
    color: #fff;
}

.view-more-btn-wrapper {
    margin-top: 50px;
    margin-bottom: 20px;
}

.view-more-btn {
    width: 122px;
    height: 34px;
    border-radius: 20px;
    border: 1px solid #F69264;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #F69568;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.view-more-btn:hover {
    cursor: pointer;
    background: #F69264;
    color: #fff;
}

.team-manage-container>>>.el-dialog__body {
    padding: 0px !important;
}

.team-manage-container>>>.el-dialog__header {
    padding: 0px !important;
}

.dialog-header {
    width: 100%;
    height: 59px;
    background: #F8FAFF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
}

.dialog-content {
    padding: 46px 77px 60px 77px;
}

.dialog-info {
    text-align: center;
}

.dialog-btn-wrapper {
    display: flex;
    margin-top: 50px;
    justify-content: space-between;
}

.dialog-btn {
    width: 140px;
    height: 38px;
    border-radius: 6px;
    border: 1px solid #3E63EE;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.dialog-cancel-btn {
    background: #fff;
    color: #3E63EE;
}

.dialog-cancel-btn:hover {
    background: #3E63EE;
    color: #fff;
    cursor: pointer;
}

.dialog-deal-btn {
    background: #3E63EE;
    color: #fff;
}

.dialog-deal-btn:hover {
    cursor: pointer;
    opacity: 0.8;
}

.no-data-wrapper {
    min-height: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.no-data-label {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666;
    margin-top: 20px;
}

.header-label {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-right: 16px;
}

.hand-back {
    cursor: pointer;
}
</style>


